<template>
  <AdminLayout>
    <Head title="Robotics" />

    <template #sectionTitle> </template>

    <template #pageTitle> Robotics </template>

    <template #leftPane>
      <div>This is some stuff</div>
    </template>

    <div class="panel"></div>
  </AdminLayout>
</template>

<script>
import { computed } from 'vue'
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head, Link, usePage, useForm } from '@inertiajs/vue3'

export default {
  components: {
    AdminLayout,
    Head,
    Link
  },

  props: {}
}
</script>
